"use client";
import { FaCoffee, FaGamepad, FaWifi } from "react-icons/fa";
import { useLanguageStore } from "@/providers/useLanguageStore";
import CarouselSite from "../Home/AboutUs/CarouselSite";
const ContactAbout = () => {
  const { translations } = useLanguageStore();

  const images = [
    "/images/site1.webp",
    "/images/site2.webp",
    "/images/site3.webp",
  ];

  return (
    <section className="relative bg-white lg:px-16 my-8 md:my-16 lg:py-24">
      <article className="grid grid-cols-12">
        <div className="col-span-1 relative hidden lg:block">
          <div className="grid grid-cols-12 grid-rows-12 h-full">
            <div className="bg-red-600 col-start-7 col-end-13 row-start-1 row-end-2"></div>
            <div className="bg-black col-start-1 col-end-7 row-start-2 row-end-3"></div>
            <div className="bg-red-400 col-start-7 col-end-13 row-start-3 row-end-13"></div>
          </div>
        </div>
        <div className=" bg-gray-100 col-span-12 lg:col-span-10 flex flex-col items-center p-8">
          <div className="w-full mb-4 relative">
            <h3 className="text-3xl font-bold text-black font-archivo lg:w-3/5">
              {translations.textCardWhoWeAre}
            </h3>
            <div className="md:flex">
              <span className="text-red-600 me-4 text-3xl font-bold">
                {translations.textCardRedWhoWeAre}
              </span>
              <span className="flex justify-start space-x-2 mt-2">
                <FaCoffee className="text-2xl text-black" />
                <FaGamepad className="text-2xl text-black" />
                <FaWifi className="text-2xl text-black" />
              </span>
            </div>
            <p className="text-gray-600 text-right font-inter lg:absolute top-0 right-0">
              {translations.address}
            </p>
            <p className="text-gray-600 text-right font-inter lg:absolute top-5 right-0">
              {translations.city}
            </p>
          </div>
          <CarouselSite images={images} />
        </div>
        <div className="col-span-1 relative hidden lg:block">
          <div className="grid grid-cols-12 grid-rows-12 h-full">
            <div className="bg-gray-400 col-start-1 col-end-7 row-start-1 row-end-11"></div>
            <div className="bg-red-600 col-start-7 col-end-13 row-start-11 row-end-12"></div>
            <div className="bg-black col-start-1 col-end-7 row-start-12 row-end-13"></div>
          </div>
        </div>
      </article>
    </section>
  );
};

export default ContactAbout;
